















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'ProductionAndroid'
})
export default class extends Vue {
  showNav = true
}
